<template>
  <div class="account-settings">
    <Header />
    <div class="settings-main">
      <div class="settings-navigation">
        <SettingsNavigation></SettingsNavigation>
      </div>
      <div class="profile">
        <div class="profile-main">
          <div class="indentation">
            उपयोक्ता विकल्प लॉग आफ करें, कृपया उपयोक्ता लॉग आफ करने के लिए चुनें
          </div>

          <div class="z-box">
            <div class="z-title">सूचना हस्ताक्षर करें</div>

            <div class="z-tips">
              हस्ताक्षर सूचना के बाद, आप कोई प्राप्त नहीं करेंगे Name लेकिन इस
              बिन्दु में, आपका खाता अभी भी इस्तेमाल किया जा सकता है, और आप
              वेओप्यूशनों को मुक्त रूप से पहुँच सकते हैं सामग्री बनाएं, संशोधनों
              में सहभागी हो जाएं, और बदला पुनरावृत्ति करें
            </div>
            <div
              :class="['update', { 'update-check': checked1 }]"
              @click="confirm1"
            >
              <div>पुष्टि करें</div>
            </div>
          </div>
          <div class="z-box">
            <div class="z-title">अपना खाता मिटाएँ</div>

            <div class="z-tips">
              अपने खाते को मिटाने के बाद, तुम अब कभी नहीं सकते किसी संशोधन में
              सहभागी करें, सामग्री बनाएँ, अपने खाते पर पहुँच करें जानकारी, या
              सामग्री बनाएँ. तुम्हारे सब बिन्दुओं को फिर सेट कर दिया जाएगा शून्य
              और प्रतिदान विमुक्ति भी रद्द किया जाएगा.
            </div>
            <div
              :class="['update', { 'update-check': checked2 }]"
              @click="confirm2"
            >
              <div>पुष्टि करें</div>
            </div>
          </div>
        </div>
      </div>
      <div class="settings-avatarurl">
        <AvatarUrl></AvatarUrl>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import SettingsNavigation from "./mycom/settingsNavigation.vue";
import AvatarUrl from "./mycom/avatarUrl.vue";
import Account from "./mycom/account.vue";
import { AccountCloseNotification, AccountClose } from "@/api/api.js";
import { Notify } from "vant";
import { Toast } from "vant";
export default {
  components: { Header, Footer, SettingsNavigation, AvatarUrl, Account },
  data() {
    return {
      checked1: false,
      checked2: false,
    };
  },
  methods: {
    confirm1() {
      this.checked1 = true;
      this.$confirm(`Are you sure to unsubscribe?`, {
        type: "warning",
        confirmButtonText: "confirm",
        cancelButtonText: "cancel",
      })
        .then(() => {
          AccountCloseNotification().then((res) => {
            if (res.code === 200) {
              Notify({
                type: "primary",
                message:
                  "The staff will respond to unsubscribe within 5 working days.",
              });
            } else {
              Notify({ type: "warning", message: res.errors });
            }
          });
        })
        .catch((action) => {});
    },
    confirm2() {
      this.checked2 = true;
      this.$confirm(`Are you sure you want to delete the account?`, {
        type: "warning",
        confirmButtonText: "confirm",
        cancelButtonText: "cancel",
      })
        .then(() => {
          AccountClose().then((res) => {
            if (res.code === 200) {
              Notify({
                type: "primary",
                message:
                  "The staff will respond to delete the account within 5 working days.",
              });
            } else {
              Notify({ type: "warning", message: res.errors });
            }
          });
        })
        .catch((action) => {});
    },
  },
  created() {},
};
</script>
<style scoped>
.account-settings {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.settings-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
  display: flex;
}
.profile {
  width: 100%;
}
.profile-main {
  width: 337.5px;
  margin-left: 40.625px;
}
.indentation {
  font-size: 12px;
  color: #232323;
  margin-bottom: 15px;
  line-height: 15px;
}
input {
  width: calc(100% - 11.25px);
  height: 28px;
  line-height: 28px;
  border-radius: 1.25px;
  border: 0.625px solid #dddddd;
  padding-left: 10px;
  font-size: 10px;
}
.input-boxs > div {
  font-size: 10px;
  margin-bottom: 7px;
  margin-top: 15px;
}
.explain {
  margin-top: 12.5px;
  font-size: 10px;
  line-height: 15px;
  margin-bottom: 12.5px;
}
.equal-rank {
  display: flex;
  justify-content: space-between;
  margin-top: 12.5px;
  margin-bottom: 10px;
}
.rank-left {
  width: calc(50% -30.625px);
}
.rank-right {
  width: calc(50% -30.625px);
}
.update {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.update > div {
  width: 81.875px;
  height: 22.5px;
  border-radius: 1.5px;
  border: 0.625px solid #2e67ea;
  text-align: center;
  line-height: 22.5px;
  margin-top: 30px;
  color: #2e67ea;
  font-size: 10px;
  cursor: pointer;
}
.update-check > div {
  background-color: #2e67ea;
  color: #fff;
}
.disabled {
  color: #dcdbe2;
  background-color: #f5f7fa;
  cursor: no-drop;
}

.z-title {
  font-size: 10px;
  margin-top: 20px;
}
.z-tips {
  font-size: 10px;
  margin-top: 15px;
}
</style>
<style scoped>
.input-boxs >>> .el-select {
  width: 100%;
}

.input-boxs >>> .el-input__inner {
  border-radius: 1.25px;
  border: 0.625px solid #dddddd;
  outline: none;
  font-size: 10px;
  padding-left: 10px;
}
.input-boxs >>> .el-input__prefix {
  display: none;
}
.input-boxs >>> .el-date-editor {
  width: 100%;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 1280px) {
  .settings-main {
    width: calc(100% - 95px);
    padding: 20px 47.5px;
  }
}
@media only screen and (max-width: 1100px) {
  .settings-avatarurl {
    display: none;
  }
}
@media only screen and (max-width: 900px) {
  .settings-main {
    width: calc(100% - 45px);
    padding: 20px 27.5px;
  }
  .profile-main {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 800px) {
  .settings-main {
    width: calc(100% - 25px);
    padding: 20px 17.5px;
  }
  .profile-main {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 768px) {
  .settings-navigation {
    display: none;
  }
  .settings-main {
    width: 100%;
    padding: 20px 0;
  }
  .profile-main {
    margin: 0 auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/settingsUnsubscribe.vue